module.exports = __webpack_public_path__ + "static/img/a5.8c16ffa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/a5.png
// module id = 29
// module chunks = 1